import { render, staticRenderFns } from "./BrRetrospect.vue?vue&type=template&id=76e2c8ba&scoped=true"
import script from "./BrRetrospect.vue?vue&type=script&lang=js"
export * from "./BrRetrospect.vue?vue&type=script&lang=js"
import style0 from "./BrRetrospect.vue?vue&type=style&index=0&id=76e2c8ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e2c8ba",
  null
  
)

export default component.exports